// App.js
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthProvider';
import { UserPrefsProvider, useUserPrefs } from './UserPrefsProvider';
import { UIProvider } from './UIContext';
import { SessionProvider } from './SessionProvider';
import { ActiveSessionProvider } from './ActiveSessionContext';
import Navigation from './Navigation';
import SessionBanner from './SessionBanner';
import Login from './Login';
import { flushPendingWrites } from './utils/flushPendingWrites';
import { RecordingProvider } from './RecordingContext';
import RecordingBanner from './components/RecordingBanner';

function AppLayout({ prefs }) {
  const { user } = useAuth();

  useEffect(() => {
    const handleOnline = () => flushPendingWrites(user);
    window.addEventListener('online', handleOnline);
    flushPendingWrites(user);
    return () => window.removeEventListener('online', handleOnline);
  }, [user]);

  return (
    <UIProvider initialUiSize={prefs.uiSize}>
      <ActiveSessionProvider>
        <RecordingProvider>
          <Navigation />
          <SessionBanner />
          <RecordingBanner />
          <Outlet />
        </RecordingProvider>
      </ActiveSessionProvider>
    </UIProvider>
  );
}

function AppLayoutWrapper() {
  const { prefs } = useUserPrefs();
  if (!prefs) return <div>Loading preferences...</div>;
  return <AppLayout prefs={prefs} />;
}

function AuthGate() {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (!user) return <Login />;

  return (
    <UserPrefsProvider>
      <AppLayoutWrapper />
    </UserPrefsProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}
